// import router from '@/router';
// import format from 'date-fns/format';

export default {
    state: {
        couponInfo: {
            couponName: ''
        }
    },
    mutations: {
        updateMessage(state: any, couponName: any) {
            state.couponInfo.couponName = couponName
        }
    }
}